// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"ua","cardInnerHeading":"ub","toggleWrapperClass":"uc","changeProfile":"ud uc","textWrapperClass":"ue","toggleTextClass":"uf"};